import React from 'react'

import { AdvancedFiltersContextProvider } from 'features/views/ListView/ListHeader/Filters/Advanced/AdvancedFiltersContext'
import { AdvancedFiltersContextValue } from 'features/views/ListView/ListHeader/Filters/Advanced/hooks/useAdvancedFiltersContext'

import { useAdvancedFiltersContextToolbarState } from './hooks/useAdvancedFiltersContextToolbarState'

type AdvancedFiltersContextToolbarProps = Pick<
    AdvancedFiltersContextValue,
    'filters' | 'addFilter' | 'removeFilter' | 'updateFilter' | 'setFilters' | 'clearFilters'
> & {
    object?: ObjectDto
}

export const AdvancedFiltersContextToolbar: React.FC<AdvancedFiltersContextToolbarProps> = ({
    children,
    object,
    filters,
    addFilter,
    removeFilter,
    updateFilter,
    setFilters,
    clearFilters,
}) => {
    const { recommendedFieldSids, availableFields } = useAdvancedFiltersContextToolbarState({
        object,
    })

    return (
        <AdvancedFiltersContextProvider
            filters={filters}
            fields={availableFields}
            addFilter={addFilter}
            removeFilter={removeFilter}
            updateFilter={updateFilter}
            setFilters={setFilters}
            clearFilters={clearFilters}
            recommendedFieldSids={recommendedFieldSids}
        >
            {children}
        </AdvancedFiltersContextProvider>
    )
}
